import api from '@motionelements/core/src/api/base-api-v2';
import { snakeCaseKeys } from '@motionelements/core/src/helpers/string.js';

// eslint-disable-next-line
export const searchArtistElements = async (mediaType, params, axiosConfig) => {
  params = params || {};
  mediaType = mediaType.replace('_', '-');
  return api.get(`/v2/search/${mediaType}`, {
    ...(axiosConfig || {}),
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
  });
};
